import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CreateCommunityService } from '../../Services/create-community.service';
import { LearnerService } from '../../Services/learner.service';
import { UserService } from '../../Services/Users.service';
declare var $;

@Component({
  selector: 'app-learner',
  templateUrl: './learner.component.html',
  styleUrls: ['./learner.component.css'],
  providers : [LearnerService,CreateCommunityService]
})
export class LearnerComponent implements OnInit {

  communityID;
  userID;
  communityData: any = {};
  userInfo: any;
  organizationList: any;
  fname: any;
  lname: any;
  designation: any;
  phone: any;
  country : string;
  comm_role = undefined;
  business_unit = undefined;
  userInfo1: any;

  constructor(
    private userService: UserService,
    private learnerService : LearnerService,
    private translate: TranslateService
  ) { }
  isIndividualLearner: boolean = true;
  ngOnInit() {
    this.userService.refreshToken();
  //  alert("abc");
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    var userID = theUser.user;
    if((userID.role == "Learner" || userID.role == "Manager") && userID.community_id == "global"){
      this.isIndividualLearner = true;
    } else {
      this.isIndividualLearner = false;
    }

    let lang_name = localStorage.getItem('defaultLang');
    this.translate.use(lang_name);

    let isCameFromLogin = sessionStorage.getItem('loginPage');
    this.userService.refreshToken();
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userID = currentUser.user.userid;
    this.communityID = currentUser.user.community_id;
    // console.log("Current user",currentUser.user);
    this.userService.usersProfilePic(this.userID).subscribe(user => {
        this.userInfo1 = user.data;
    //  console.log(this.userInfo1.designation,"userinfo111")
     
      if(!this.userInfo1.user_kyc && isCameFromLogin == 'yes' || !this.userInfo1.country ||!this.userInfo1.comm_role ||!this.userInfo1.business_unit || !this.userInfo1.first_name || !this.userInfo1.last_name || !this.userInfo1.phone || !this.userInfo1.designation){
        this.learnerService.getSelectedCommunity(this.communityID).subscribe(community => {
         
          console.log("kyc config array",community.data.kyc_config[0]);
          if(community && community.success){
            // alert("community true");
            // console.log(this.userInfo1,"userinfo222")
            let country = this.userInfo1.country;
            let comm_role = this.userInfo1.comm_role;
            let business_unit = this.userInfo1.business_unit;
            let firstname = this.userInfo1.first_name;
            let lastname = this.userInfo1.last_name;
            let phone = this.userInfo1.phone;
            let designation = this.userInfo1.designation;

            this.communityData = community.data && community.data.kyc_config && community.data.kyc_config[0] ? community.data.kyc_config[0] : {};
            if(community.data && community.data.kyc_config && community.data.kyc_config[0]){
              // alert("community kyc_config true");
              if(!community.data.kyc_config[0].role_kyc && !community.data.kyc_config[0].business_unit_kyc && !community.data.kyc_config[0].country_kyc && !community.data.kyc_config[0].fname_kyc && !community.data.kyc_config[0].lname_kyc && !community.data.kyc_config[0].designation_kyc && !community.data.kyc_config[0].phone_kyc){
                // alert("community kyc_config some not there");
                $('#userKYCModal').modal('hide');
                sessionStorage.removeItem('loginPage');
              }else if((community.data.kyc_config[0].fname_kyc ? (firstname ? true: false) : true) && (community.data.kyc_config[0].designation_kyc ? (designation ? true: false) : true) && (community.data.kyc_config[0].phone_kyc ? (phone ? true: false) : true) && (community.data.kyc_config[0].lname_kyc ? (lastname ? true: false) : true) && (community.data.kyc_config[0].role_kyc ? (comm_role ? true: false) : true) && (community.data.kyc_config[0].business_unit_kyc ? (business_unit ? true: false) : true) && (community.data.kyc_config[0].country_kyc ? (country ? true: false) : true)){
                // alert("Some are not set");
                $('#userKYCModal').modal('hide');
                sessionStorage.removeItem('loginPage');
              } else
                $('#userKYCModal').modal('show');
            } else
              $('#userKYCModal').modal('hide');

          } else {
            $('#userKYCModal').modal('hide');
            sessionStorage.removeItem('loginPage');
          }
        });
      
      } else
        sessionStorage.removeItem('loginPage');
    // } else
    //   sessionStorage.removeItem('loginPage');
  });
  }
  

  toggleSidenav(){
    $('.text').toggle(280);
    $('.menu').toggleClass('width240');
    $('.menu').toggleClass('width90');
    $('.main').toggleClass('marginLft70');
    $('.leftArrow').toggleClass('rightArrow');
    $('.rightArrowAlign').toggleClass('leftArrowAlign');

  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/learner/learner.component.ts